import { api } from "./axios";
import { makeFilterString } from './utils';

export async function getUsers(type, objFilter) {
    let res = await api.get("user/get/" + type + "/" + makeFilterString(objFilter));
    if (res) return res.data.data;
    else return false;
}

export async function getUsersByFilter(body, objFilter) {
    let res = await api.post("user/user_filter/" + makeFilterString(objFilter), body);
    if (res) return res.data;
    else return false;
}

export async function createUsers(data) {
    let res = await api.post("user/create/", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateUsers(id, data) {
    let res = await api.post("user/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

export async function deleteUsers(id) {
    let res = await api.get("user/delete/" + id);
    if (res) return res.data.message;
    else return false;
}

export async function getUserDetails(id) {
    let res = await api.get("user/show/" + id);
    if (res) return res.data.data;
    else return false;
}


